import { useRef } from "react";
import { Modal } from "react-bootstrap";
import Invoice from "../Invoice/Invoice";
import { App } from "antd";
const BillSettings = ({
  open,
  onClose = () => {},
  isAdvanceSetting = false,
}) => {
  const alertMsg = useRef();
  return (
    <App>
      <Modal
        show={open}
        style={{ width: "90%", marginLeft: "5%" }}
        dialogClassName="custom-modal"
        onHide={() => onClose()}
        ref={alertMsg}
      >
        <div className="modal-content" style={{ position: "absolute" }}>
          <Modal.Header closeButton>
            <h3 style={{ color: "#EF4667" }}>
              {isAdvanceSetting ? "Advance Settings" : "Invoice Customization"}
            </h3>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                width: "100%",
                maxWidth: "fill-available",
                backgroundColor: "#F5F9FC",
              }}
            >
              <Invoice
                mode={isAdvanceSetting ? "advance" : "bill"}
                ref={alertMsg}
                onHide={() => onClose()}
              />
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </App>
  );
};

export default BillSettings;
